(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[82765,93812,49617,31566,35767,92093],{

/***/ 49617:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_CallToAction; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./UI/components/Illustration/index.jsx + 1 modules
var Illustration = __webpack_require__(93812);
// EXTERNAL MODULE: ./utils/constants/linkType.js
var linkType = __webpack_require__(45177);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
// EXTERNAL MODULE: ./utils/downloadFile.js
var downloadFile = __webpack_require__(48031);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
// EXTERNAL MODULE: ./UI/components/CallToAction/styles.module.scss
var styles_module = __webpack_require__(73331);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/CallToAction/utils/useProps.js












var PAGES_WITH_CONTACT = [
    constants/* ROUTES.aiSoftwareDevelopmentServices.slug */.y2.aiSoftwareDevelopmentServices.slug
];
/* harmony default export */ function useProps(props) {
    var scrollTop = function scrollTop() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    var downloadFileAction = function downloadFileAction() {
        return (0,downloadFile/* default */.Z)(files[0]);
    };
    var page = props.page, view = props.view, titleProp = props.title, data = props.data, buttonTitleProp = props.buttonTitle, className = props.className, slugProp = props.slug, pageType = props.pageType, rest = (0,_object_without_properties/* default */.Z)(props, [
        "page",
        "view",
        "title",
        "data",
        "buttonTitle",
        "className",
        "slug",
        "pageType"
    ]);
    var ref = (0,helper/* getDocumentFields */.OA)(data, [
        "title",
        "subtitle",
        "new",
        "imagesBundle",
        "buttonTitle",
        "type",
        "files",
        "isOpenFeedbackForm",
        "url", 
    ]), isNew = ref.new, title = ref.title, subtitle = ref.subtitle, imagesBundle = ref.imagesBundle, buttonTitle = ref.buttonTitle, rawFiles = ref.files, type = ref.type, isOpenFeedbackForm = ref.isOpenFeedbackForm, ctaUrl = ref.url;
    var ref1 = (0,react.useState)(false), show = ref1[0], setShow = ref1[1];
    var ref2 = (0,router.useRouter)(), slug = ref2.query.slug;
    var images = (imagesBundle || []).map(helper/* getImage */.gJ);
    var titles = (title || titleProp).split("||");
    var files = (rawFiles || []).map(helper/* getFileUrl */.qm);
    var _obj;
    var classNames = classnames_default()((styles_module_default()).container, (styles_module_default())[type], (styles_module_default())[view], (styles_module_default())[page], className, (_obj = {}, (0,_define_property/* default */.Z)(_obj, (styles_module_default()).openContact, isOpenFeedbackForm), (0,_define_property/* default */.Z)(_obj, (styles_module_default()).scrollBlock, type === linkType/* LINK_TYPE.scrollBlock */.x.scrollBlock), (0,_define_property/* default */.Z)(_obj, (styles_module_default()).showScrollBlock, type === linkType/* LINK_TYPE.scrollBlock */.x.scrollBlock && show), _obj));
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
        titles: titles,
        subtitle: subtitle,
        images: images,
        isNew: isNew,
        buttonTitle: buttonTitleProp || buttonTitle,
        type: type,
        downloadLink: files[0],
        isOpenFeedbackForm: isOpenFeedbackForm,
        slug: slugProp || slug,
        ctaUrl: ctaUrl,
        show: show,
        classNames: classNames,
        setShow: setShow,
        scrollTop: scrollTop,
        downloadFileAction: downloadFileAction,
        withContact: PAGES_WITH_CONTACT.includes(pageType)
    });
};

;// CONCATENATED MODULE: ./UI/components/CallToAction/index.jsx








var Contact = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 82407).then(__webpack_require__.bind(__webpack_require__, 82407));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(82407)
            ];
        }
    }
});
var GetBook = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(24168), __webpack_require__.e(57330), __webpack_require__.e(51985)]).then(__webpack_require__.bind(__webpack_require__, 51985));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(51985)
            ];
        }
    }
});
var Subscribe = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(24168), __webpack_require__.e(57330), __webpack_require__.e(51246)]).then(__webpack_require__.bind(__webpack_require__, 51246));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(51246)
            ];
        }
    }
});
var ScrollBlock = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(24168), __webpack_require__.e(57330), __webpack_require__.e(110)]).then(__webpack_require__.bind(__webpack_require__, 110));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(110)
            ];
        }
    }
});
var CallToAction = function(props) {
    var ref = useProps(props), titles = ref.titles, subtitle = ref.subtitle, buttonTitle = ref.buttonTitle, type = ref.type, images = ref.images, downloadLink = ref.downloadLink, handleOnClick = ref.handleOnClick, slug = ref.slug, ctaUrl = ref.ctaUrl, sectionRef = ref.sectionRef, show = ref.show, setShow = ref.setShow, classNames = ref.classNames, scrollTop = ref.scrollTop, downloadFileAction = ref.downloadFileAction, withContact = ref.withContact;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classNames,
        children: [
            images.map(function(param, i) {
                var url = param.url, alt = param.alt;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Illustration["default"], {
                    src: url,
                    alt: alt,
                    className: classnames_default()((styles_module_default()).image, (styles_module_default())["image-".concat(i)])
                });
            }),
            function() {
                switch(type){
                    case linkType/* LINK_TYPE.subscribe */.x.subscribe:
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Subscribe, {
                            titles: titles,
                            subtitle: subtitle,
                            buttonTitle: buttonTitle,
                            slug: slug
                        });
                    case linkType/* LINK_TYPE.book */.x.book:
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(GetBook, {
                            titles: titles,
                            subtitle: subtitle,
                            buttonTitle: buttonTitle,
                            bookCover: images[0],
                            downloadLink: downloadLink,
                            slug: slug,
                            withContact: withContact
                        });
                    case linkType/* LINK_TYPE.callToAction */.x.callToAction:
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Contact, {
                            titles: titles,
                            subtitle: subtitle,
                            buttonTitle: buttonTitle,
                            handleOnClick: handleOnClick,
                            url: ctaUrl
                        });
                    case linkType/* LINK_TYPE.scrollBlock */.x.scrollBlock:
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollBlock, {
                            sectionRef: sectionRef,
                            titles: titles,
                            subtitle: subtitle,
                            buttonTitle: buttonTitle,
                            bookCover: images[0],
                            downloadLink: downloadLink,
                            slug: slug,
                            show: show,
                            setShow: setShow
                        });
                    case linkType/* LINK_TYPE.scrollTop */.x.scrollTop:
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Contact, {
                            titles: titles,
                            subtitle: subtitle,
                            buttonTitle: buttonTitle,
                            handleOnClick: scrollTop,
                            url: ctaUrl
                        });
                    case linkType/* LINK_TYPE.download */.x.download:
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Contact, {
                            titles: titles,
                            subtitle: subtitle,
                            buttonTitle: buttonTitle,
                            handleOnClick: downloadFileAction,
                            url: ctaUrl
                        });
                    default:
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Contact, {
                            titles: titles,
                            subtitle: subtitle,
                            buttonTitle: buttonTitle,
                            handleOnClick: handleOnClick,
                            url: ctaUrl
                        });
                }
            }()
        ]
    });
};
CallToAction.defaultProps = {
    href: "",
    className: null,
    title: "",
    subtitle: "",
    data: {}
};
CallToAction.propTypes = {
    data: prop_types_default().instanceOf(Object),
    title: (prop_types_default()).string,
    subtitle: (prop_types_default()).string,
    buttonTitle: (prop_types_default()).string,
    href: (prop_types_default()).string,
    type: (prop_types_default()).string,
    handleOnClick: (prop_types_default()).func,
    className: (prop_types_default()).string
};
/* harmony default export */ var components_CallToAction = (CallToAction);


/***/ }),

/***/ 93812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_Illustration; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var node_modules_classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(node_modules_classnames);
// EXTERNAL MODULE: ./UI/components/Illustration/utils/helpers.js
var helpers = __webpack_require__(45783);
// EXTERNAL MODULE: ./UI/components/Illustration/styles.module.scss
var styles_module = __webpack_require__(31890);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/Illustration/utils/useIllustration.js





/* harmony default export */ function useIllustration(_param) {
    var src = _param.src, isStatic = _param.isStatic, classnames = _param.className, _lazyBoundary = _param.lazyBoundary, lazyBoundary = _lazyBoundary === void 0 ? "700px" : _lazyBoundary, apiParams = _param.apiParams, transparent = _param.transparent, placeholderProp = _param.placeholder, priority = _param.priority, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "src",
        "isStatic",
        "className",
        "lazyBoundary",
        "apiParams",
        "transparent",
        "placeholder",
        "priority"
    ]);
    var loader = isStatic ? function(param) {
        var staticSrc = param.src;
        return staticSrc;
    } : function(args) {
        return (0,helpers/* getContentfulImage */.t)((0,_object_spread/* default */.Z)({
            transparent: transparent
        }, args, apiParams));
    };
    var className = classnames_default()((styles_module_default()).image, classnames);
    var lazyProps = !priority ? {
        placeholder: placeholderProp || (transparent ? "blur" : "empty"),
        blurDataURL: (0,helpers/* getContentfulImage */.t)({
            src: src,
            quality: 1,
            format: "webp",
            transparent: transparent
        })
    } : {};
    return (0,_object_spread/* default */.Z)({
        src: src,
        loader: loader,
        className: className,
        lazyBoundary: lazyBoundary,
        priority: priority
    }, lazyProps, rest);
};

;// CONCATENATED MODULE: ./UI/components/Illustration/index.jsx








var Illustration = /*#__PURE__*/ (0,react.memo)(function(props) {
    var _ref = useIllustration(props), className = _ref.className, style = _ref.style, containerClasses = _ref.containerClasses, restProps = (0,_object_without_properties/* default */.Z)(_ref, [
        "className",
        "style",
        "containerClasses"
    ]);
    if (!(restProps === null || restProps === void 0 ? void 0 : restProps.src) || restProps.placeholder === "blur" && !restProps.blurDataURL) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("picture", {
        className: classnames_default()(className, containerClasses),
        style: style,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), (0,_object_spread/* default */.Z)({}, restProps))
    });
});
Illustration.defaultProps = {
    layout: "fill",
    alt: "",
    transparent: false,
    apiParams: {}
};
Illustration.propTypes = {
    transparent: (prop_types_default()).bool,
    // For more props check https://nextjs.org/docs/api-reference/next/legacy/image
    src: (prop_types_default()).string.isRequired,
    alt: (prop_types_default()).string,
    layout: prop_types_default().oneOf([
        "fill",
        "intrinsic",
        "fixed",
        "responsive", 
    ]),
    placeholder: prop_types_default().oneOf([
        "blur",
        "empty", 
    ]),
    // Check https://www.contentful.com/developers/docs/references/images-api/ for detailed api
    apiParams: prop_types_default().instanceOf(Object)
};
/* harmony default export */ var components_Illustration = (Illustration);


/***/ }),

/***/ 35565:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ containers_CardContainer; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./UI/containers/CardContainer/CardContainer.module.scss
var CardContainer_module = __webpack_require__(14910);
var CardContainer_module_default = /*#__PURE__*/__webpack_require__.n(CardContainer_module);
;// CONCATENATED MODULE: ./UI/containers/CardContainer/utils/useCardContainer.js





/* harmony default export */ function useCardContainer(_param) {
    var children = _param.children, classes = _param.className, noBackground = _param.noBackground, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "className",
        "noBackground"
    ]);
    var className = classnames_default()((CardContainer_module_default()).cardContainer, classes, (0,_define_property/* default */.Z)({}, (CardContainer_module_default()).noBackground, noBackground));
    return (0,_object_spread/* default */.Z)({
        children: children,
        className: className
    }, rest);
};

;// CONCATENATED MODULE: ./UI/containers/CardContainer/index.jsx







var CardContainer = function(props, ref) {
    var _ref = useCardContainer(props), children = _ref.children, className = _ref.className, restProps = (0,_object_without_properties/* default */.Z)(_ref, [
        "children",
        "className"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: className,
        ref: ref
    }, restProps), {
        children: children
    }));
};
CardContainer.propTypes = {
    children: (prop_types_default()).node.isRequired,
    noBackground: (prop_types_default()).bool,
    className: (prop_types_default()).string
};
/* harmony default export */ var containers_CardContainer = (/*#__PURE__*/(0,react.forwardRef)(CardContainer));


/***/ }),

/***/ 55410:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ sections_SliderSection; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 92 modules
var swiper_esm = __webpack_require__(44040);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(30933);
// EXTERNAL MODULE: ./node_modules/swiper/modules/scrollbar/scrollbar.min.css
var scrollbar_min = __webpack_require__(13390);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./UI/components/SectionTitle/index.jsx
var SectionTitle = __webpack_require__(15805);
// EXTERNAL MODULE: ./UI/containers/CardContainer/index.jsx + 1 modules
var CardContainer = __webpack_require__(35565);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
// EXTERNAL MODULE: ./UI/components/CallToAction/index.jsx + 1 modules
var CallToAction = __webpack_require__(49617);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__(2664);
// EXTERNAL MODULE: ./redux/selectors/layout.js
var layout = __webpack_require__(19341);
// EXTERNAL MODULE: ./utils/routes.js
var routes = __webpack_require__(27727);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
;// CONCATENATED MODULE: ./UI/sections/SliderSection/utils/helpers.js

var typesDependencies = function(type) {
    return [
        constants/* ROUTES.aiChatbotDevelopmentServices.slug */.y2.aiChatbotDevelopmentServices.slug,
        constants/* ROUTES.aiStaffAugmentationServices.slug */.y2.aiStaffAugmentationServices.slug,
        constants/* ROUTES.aiConsulting.slug */.y2.aiConsulting.slug, 
    ].includes(type);
};

;// CONCATENATED MODULE: ./UI/sections/SliderSection/utils/useSectionProps.js








var SPECIFIC_SETTINGS = (0,_define_property/* default */.Z)({}, routes/* routes.aiAgentsServices.slug */._.aiAgentsServices.slug, {
    slidesPerView: 1,
    spaceBetween: 32,
    slidesPerGroup: 1,
    breakpoints: {
        569: {
            slidesPerView: 1,
            slidesPerGroup: 1,
            centeredSlides: false
        },
        760: {
            slidesPerView: 2,
            slidesPerGroup: 2,
            centeredSlides: false
        }
    }
});
/* harmony default export */ function useSectionProps(props) {
    var sectionData = props.sectionData, type = props.type, handleOnCTAClick = props.handleOnCTAClick;
    var ref = (0,helper/* getDocumentFields */.OA)(sectionData, [
        "title",
        "subtitle",
        "description",
        "contentModules", 
    ]), title = ref.title, subtitle = ref.subtitle, description = ref.description, contentModules = ref.contentModules;
    var isDesktop = (0,es.useSelector)(layout/* selectIsDesktop */.Y6);
    var disabledOnDesktop = typesDependencies(type) && isDesktop;
    var ctaLink = (0,lodash.get)(contentModules, "[1]");
    var slides = (0,helper/* getDocumentFields */.OA)((0,lodash.get)(contentModules, "[0]", []), [
        "contentModules"
    ]).contentModules.map(function(slide) {
        var ref = (0,helper/* getDocumentFields */.OA)(slide, [
            "title",
            "description",
            "text", 
        ]), slideTitle = ref.title, slideDescription = ref.description, text = ref.text;
        return {
            slideTitle: slideTitle,
            slideDescription: slideDescription,
            text: text
        };
    });
    var params = (0,_object_spread/* default */.Z)({
        slidesPerView: 1,
        spaceBetween: 32,
        slidesPerGroup: 1,
        mousewheel: {
            forceToAxis: true
        },
        scrollbar: {
            el: ".swiper-scrollbar"
        },
        breakpoints: {
            1025: {
                slidesPerGroup: 2,
                slidesPerView: 2
            }
        }
    }, SPECIFIC_SETTINGS[type]);
    return {
        title: title,
        subtitle: subtitle,
        description: description,
        slides: slides,
        params: params,
        ctaLink: ctaLink,
        type: type,
        handleOnCTAClick: handleOnCTAClick,
        disabledOnDesktop: disabledOnDesktop
    };
};

// EXTERNAL MODULE: ./UI/sections/SliderSection/styles.module.scss
var styles_module = __webpack_require__(88120);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/sections/SliderSection/index.jsx
















var Animated = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 61971).then(__webpack_require__.bind(__webpack_require__, 61971));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61971)
            ];
        }
    }
});
var ContentfulParser = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 92870));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(92870)
            ];
        }
    },
    ssr: false
});
swiper_esm/* default.use */.ZP.use([
    swiper_esm/* Scrollbar */.LW,
    swiper_esm/* Mousewheel */.Gk, 
]);
var SliderSection = function(props) {
    var ref = useSectionProps(props), title = ref.title, subtitle = ref.subtitle, description = ref.description, slides = ref.slides, params = ref.params, ctaLink = ref.ctaLink, type = ref.type, handleOnCTAClick = ref.handleOnCTAClick, disabledOnDesktop = ref.disabledOnDesktop;
    if (!slides || !slides.length) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: classnames_default()((styles_module_default()).sliderSection, (styles_module_default())[type]),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (styles_module_default()).contentWrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle["default"], {
                    title: title,
                    subtitle: subtitle,
                    description: description,
                    titleStyle: (styles_module_default()).titleStyle
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContainer/* default */.Z, {
                    className: (styles_module_default()).sliderList,
                    children: disabledOnDesktop ? slides.map(function(param) {
                        var slideTitle = param.slideTitle, slideDescription = param.slideDescription, text = param.text;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (styles_module_default()).item,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: (styles_module_default()).slideTitle,
                                    children: slideTitle
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: (styles_module_default()).slideSubtitle,
                                    children: slideDescription
                                }),
                                text && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentfulParser, {
                                    document: text
                                })
                            ]
                        }, "slides/".concat(slideTitle));
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* REVEAL_ANIMATION_PROPS */.kt), {
                        transitionDelay: 50,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params), {
                            scrollbar: {
                                draggable: true
                            },
                            children: slides.map(function(param) {
                                var slideTitle = param.slideTitle, slideDescription = param.slideDescription, text = param.text;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* SwiperSlide */.o5, {
                                    className: (styles_module_default()).item,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: (styles_module_default()).slideTitle,
                                            children: slideTitle
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: (styles_module_default()).slideSubtitle,
                                            children: slideDescription
                                        }),
                                        text && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentfulParser, {
                                            document: text
                                        })
                                    ]
                                }, "slides/".concat(slideTitle));
                            })
                        }))
                    }))
                }),
                ctaLink && /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* REVEAL_ANIMATION_PROPS */.kt), {
                    transitionDelay: 50,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CallToAction["default"], {
                        data: ctaLink,
                        handleOnClick: handleOnCTAClick,
                        className: (styles_module_default()).callToAction
                    })
                }))
            ]
        })
    });
};
SliderSection.propTypes = {
    sectionData: prop_types_default().instanceOf(Object).isRequired,
    type: (prop_types_default()).string.isRequired
};
/* harmony default export */ var sections_SliderSection = (SliderSection);


/***/ }),

/***/ 45177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ LINK_TYPE; }
/* harmony export */ });
var LINK_TYPE = {
    bookmark: "bookmark",
    callToAction: "call-to-action",
    button: "button",
    youTube: "youtube-video",
    book: "book",
    subscribe: "subscribe",
    scrollBlock: "scroll-block",
    scrollTop: "scroll-top",
    scrollToSection: "scroll-to-section",
    download: "download"
};


/***/ }),

/***/ 48031:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ downloadFile; }
/* harmony export */ });
function downloadFile(fileUrl) {
    var anchor = document.createElement("a");
    anchor.href = fileUrl;
    anchor.download = true;
    anchor.target = "_blank";
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
}


/***/ }),

/***/ 73331:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"web-app-development-company":"styles_web-app-development-company__1HB5w","h3":"styles_h3__IRjjx","container":"styles_container__pO5_j","content":"styles_content__xSHAX","title":"styles_title__KGr5K","image":"styles_image__G8OXV","subtitle":"styles_subtitle__CZxyq","button":"styles_button__Zx8JO","openContact":"styles_openContact__P9cjT","book":"styles_book__gorl4","subscribe":"styles_subscribe__OZAA7","isSubscribed":"styles_isSubscribed__ywNq6","page":"styles_page___1I_h","p":"styles_p__91NqR","scrollBlock":"styles_scrollBlock__YSLoG","showScrollBlock":"styles_showScrollBlock__5hZIR"};

/***/ }),

/***/ 31890:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"image":"styles_image__T17hn"};

/***/ }),

/***/ 14910:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"CardContainer_cardContainer__GnP7H","noBackground":"CardContainer_noBackground__jHEZf","sb_cardWithOverlay":"CardContainer_sb_cardWithOverlay__guDiR","overlay":"CardContainer_overlay__xSItN"};

/***/ }),

/***/ 88120:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cardsWithFullWidthImage":"styles_cardsWithFullWidthImage__b3JjX","cards":"styles_cards__OnAq_","imageWrapper":"styles_imageWrapper__e7Cks","typeTitle":"styles_typeTitle__4FjO4","greySection":"styles_greySection__b2CUa","callToAction":"styles_callToAction__VqRG2","threeColumnsCards":"styles_threeColumnsCards__f_nku","twoColumnsCards":"styles_twoColumnsCards__GeGOp","textContent":"styles_textContent__1AXX5","sliderSection":"styles_sliderSection__NT756","contentWrapper":"styles_contentWrapper__3bKYy","sliderList":"styles_sliderList__dAfSY","item":"styles_item__I_h_2","slideTitle":"styles_slideTitle__Fcroy","enterprise-resource-planning-software-services":"styles_enterprise-resource-planning-software-services__iiqAy","slideSubtitle":"styles_slideSubtitle___2esi","chat-app-development-company":"styles_chat-app-development-company__dOn2l","fintech-software-development-services":"styles_fintech-software-development-services__hAb92","titleStyle":"styles_titleStyle__2ll50","trading-software-development":"styles_trading-software-development__zRWxc","payment-gateway-development-company":"styles_payment-gateway-development-company__4b2cZ","generative-ai-services":"styles_generative-ai-services__AuP6B","ai-chatbot-development-services":"styles_ai-chatbot-development-services__AFhsi","ai-staff-augmentation-services":"styles_ai-staff-augmentation-services__JM4kY","ai-consulting-services":"styles_ai-consulting-services__91Izs","logistics-software-development-services":"styles_logistics-software-development-services__5z3fQ","e-commerce-development":"styles_e-commerce-development__7_Dky","educational-software-development-services":"styles_educational-software-development-services__DKuD1","ai-agent-development-services":"styles_ai-agent-development-services__QQScv","llm-development-services":"styles_llm-development-services__IskKh","ai-voice-assistant-development-services":"styles_ai-voice-assistant-development-services__VLJnh","rag-development-services":"styles_rag-development-services__yAP8p","mlops-development-services":"styles_mlops-development-services__2aOuL","data-science-development-company":"styles_data-science-development-company__DBygS","ai-managed-pod":"styles_ai-managed-pod__cm7wP","influx":"styles_influx__l6Uty","futurepay":"styles_futurepay__CuLtL","commod":"styles_commod__xoHel"};

/***/ }),

/***/ 13390:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 30933:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 31304:
/***/ (function(module) {


;(function (name, root, factory) {
  if (true) {
    module.exports = factory()
    module.exports["default"] = factory()
  }
  /* istanbul ignore next */
  else {}
}('slugify', this, function () {
  var charMap = JSON.parse('{"$":"dollar","%":"percent","&":"and","<":"less",">":"greater","|":"or","¢":"cent","£":"pound","¤":"currency","¥":"yen","©":"(c)","ª":"a","®":"(r)","º":"o","À":"A","Á":"A","Â":"A","Ã":"A","Ä":"A","Å":"A","Æ":"AE","Ç":"C","È":"E","É":"E","Ê":"E","Ë":"E","Ì":"I","Í":"I","Î":"I","Ï":"I","Ð":"D","Ñ":"N","Ò":"O","Ó":"O","Ô":"O","Õ":"O","Ö":"O","Ø":"O","Ù":"U","Ú":"U","Û":"U","Ü":"U","Ý":"Y","Þ":"TH","ß":"ss","à":"a","á":"a","â":"a","ã":"a","ä":"a","å":"a","æ":"ae","ç":"c","è":"e","é":"e","ê":"e","ë":"e","ì":"i","í":"i","î":"i","ï":"i","ð":"d","ñ":"n","ò":"o","ó":"o","ô":"o","õ":"o","ö":"o","ø":"o","ù":"u","ú":"u","û":"u","ü":"u","ý":"y","þ":"th","ÿ":"y","Ā":"A","ā":"a","Ă":"A","ă":"a","Ą":"A","ą":"a","Ć":"C","ć":"c","Č":"C","č":"c","Ď":"D","ď":"d","Đ":"DJ","đ":"dj","Ē":"E","ē":"e","Ė":"E","ė":"e","Ę":"e","ę":"e","Ě":"E","ě":"e","Ğ":"G","ğ":"g","Ģ":"G","ģ":"g","Ĩ":"I","ĩ":"i","Ī":"i","ī":"i","Į":"I","į":"i","İ":"I","ı":"i","Ķ":"k","ķ":"k","Ļ":"L","ļ":"l","Ľ":"L","ľ":"l","Ł":"L","ł":"l","Ń":"N","ń":"n","Ņ":"N","ņ":"n","Ň":"N","ň":"n","Ō":"O","ō":"o","Ő":"O","ő":"o","Œ":"OE","œ":"oe","Ŕ":"R","ŕ":"r","Ř":"R","ř":"r","Ś":"S","ś":"s","Ş":"S","ş":"s","Š":"S","š":"s","Ţ":"T","ţ":"t","Ť":"T","ť":"t","Ũ":"U","ũ":"u","Ū":"u","ū":"u","Ů":"U","ů":"u","Ű":"U","ű":"u","Ų":"U","ų":"u","Ŵ":"W","ŵ":"w","Ŷ":"Y","ŷ":"y","Ÿ":"Y","Ź":"Z","ź":"z","Ż":"Z","ż":"z","Ž":"Z","ž":"z","Ə":"E","ƒ":"f","Ơ":"O","ơ":"o","Ư":"U","ư":"u","ǈ":"LJ","ǉ":"lj","ǋ":"NJ","ǌ":"nj","Ș":"S","ș":"s","Ț":"T","ț":"t","ə":"e","˚":"o","Ά":"A","Έ":"E","Ή":"H","Ί":"I","Ό":"O","Ύ":"Y","Ώ":"W","ΐ":"i","Α":"A","Β":"B","Γ":"G","Δ":"D","Ε":"E","Ζ":"Z","Η":"H","Θ":"8","Ι":"I","Κ":"K","Λ":"L","Μ":"M","Ν":"N","Ξ":"3","Ο":"O","Π":"P","Ρ":"R","Σ":"S","Τ":"T","Υ":"Y","Φ":"F","Χ":"X","Ψ":"PS","Ω":"W","Ϊ":"I","Ϋ":"Y","ά":"a","έ":"e","ή":"h","ί":"i","ΰ":"y","α":"a","β":"b","γ":"g","δ":"d","ε":"e","ζ":"z","η":"h","θ":"8","ι":"i","κ":"k","λ":"l","μ":"m","ν":"n","ξ":"3","ο":"o","π":"p","ρ":"r","ς":"s","σ":"s","τ":"t","υ":"y","φ":"f","χ":"x","ψ":"ps","ω":"w","ϊ":"i","ϋ":"y","ό":"o","ύ":"y","ώ":"w","Ё":"Yo","Ђ":"DJ","Є":"Ye","І":"I","Ї":"Yi","Ј":"J","Љ":"LJ","Њ":"NJ","Ћ":"C","Џ":"DZ","А":"A","Б":"B","В":"V","Г":"G","Д":"D","Е":"E","Ж":"Zh","З":"Z","И":"I","Й":"J","К":"K","Л":"L","М":"M","Н":"N","О":"O","П":"P","Р":"R","С":"S","Т":"T","У":"U","Ф":"F","Х":"H","Ц":"C","Ч":"Ch","Ш":"Sh","Щ":"Sh","Ъ":"U","Ы":"Y","Ь":"","Э":"E","Ю":"Yu","Я":"Ya","а":"a","б":"b","в":"v","г":"g","д":"d","е":"e","ж":"zh","з":"z","и":"i","й":"j","к":"k","л":"l","м":"m","н":"n","о":"o","п":"p","р":"r","с":"s","т":"t","у":"u","ф":"f","х":"h","ц":"c","ч":"ch","ш":"sh","щ":"sh","ъ":"u","ы":"y","ь":"","э":"e","ю":"yu","я":"ya","ё":"yo","ђ":"dj","є":"ye","і":"i","ї":"yi","ј":"j","љ":"lj","њ":"nj","ћ":"c","ѝ":"u","џ":"dz","Ґ":"G","ґ":"g","Ғ":"GH","ғ":"gh","Қ":"KH","қ":"kh","Ң":"NG","ң":"ng","Ү":"UE","ү":"ue","Ұ":"U","ұ":"u","Һ":"H","һ":"h","Ә":"AE","ә":"ae","Ө":"OE","ө":"oe","Ա":"A","Բ":"B","Գ":"G","Դ":"D","Ե":"E","Զ":"Z","Է":"E\'","Ը":"Y\'","Թ":"T\'","Ժ":"JH","Ի":"I","Լ":"L","Խ":"X","Ծ":"C\'","Կ":"K","Հ":"H","Ձ":"D\'","Ղ":"GH","Ճ":"TW","Մ":"M","Յ":"Y","Ն":"N","Շ":"SH","Չ":"CH","Պ":"P","Ջ":"J","Ռ":"R\'","Ս":"S","Վ":"V","Տ":"T","Ր":"R","Ց":"C","Փ":"P\'","Ք":"Q\'","Օ":"O\'\'","Ֆ":"F","և":"EV","ء":"a","آ":"aa","أ":"a","ؤ":"u","إ":"i","ئ":"e","ا":"a","ب":"b","ة":"h","ت":"t","ث":"th","ج":"j","ح":"h","خ":"kh","د":"d","ذ":"th","ر":"r","ز":"z","س":"s","ش":"sh","ص":"s","ض":"dh","ط":"t","ظ":"z","ع":"a","غ":"gh","ف":"f","ق":"q","ك":"k","ل":"l","م":"m","ن":"n","ه":"h","و":"w","ى":"a","ي":"y","ً":"an","ٌ":"on","ٍ":"en","َ":"a","ُ":"u","ِ":"e","ْ":"","٠":"0","١":"1","٢":"2","٣":"3","٤":"4","٥":"5","٦":"6","٧":"7","٨":"8","٩":"9","پ":"p","چ":"ch","ژ":"zh","ک":"k","گ":"g","ی":"y","۰":"0","۱":"1","۲":"2","۳":"3","۴":"4","۵":"5","۶":"6","۷":"7","۸":"8","۹":"9","฿":"baht","ა":"a","ბ":"b","გ":"g","დ":"d","ე":"e","ვ":"v","ზ":"z","თ":"t","ი":"i","კ":"k","ლ":"l","მ":"m","ნ":"n","ო":"o","პ":"p","ჟ":"zh","რ":"r","ს":"s","ტ":"t","უ":"u","ფ":"f","ქ":"k","ღ":"gh","ყ":"q","შ":"sh","ჩ":"ch","ც":"ts","ძ":"dz","წ":"ts","ჭ":"ch","ხ":"kh","ჯ":"j","ჰ":"h","Ṣ":"S","ṣ":"s","Ẁ":"W","ẁ":"w","Ẃ":"W","ẃ":"w","Ẅ":"W","ẅ":"w","ẞ":"SS","Ạ":"A","ạ":"a","Ả":"A","ả":"a","Ấ":"A","ấ":"a","Ầ":"A","ầ":"a","Ẩ":"A","ẩ":"a","Ẫ":"A","ẫ":"a","Ậ":"A","ậ":"a","Ắ":"A","ắ":"a","Ằ":"A","ằ":"a","Ẳ":"A","ẳ":"a","Ẵ":"A","ẵ":"a","Ặ":"A","ặ":"a","Ẹ":"E","ẹ":"e","Ẻ":"E","ẻ":"e","Ẽ":"E","ẽ":"e","Ế":"E","ế":"e","Ề":"E","ề":"e","Ể":"E","ể":"e","Ễ":"E","ễ":"e","Ệ":"E","ệ":"e","Ỉ":"I","ỉ":"i","Ị":"I","ị":"i","Ọ":"O","ọ":"o","Ỏ":"O","ỏ":"o","Ố":"O","ố":"o","Ồ":"O","ồ":"o","Ổ":"O","ổ":"o","Ỗ":"O","ỗ":"o","Ộ":"O","ộ":"o","Ớ":"O","ớ":"o","Ờ":"O","ờ":"o","Ở":"O","ở":"o","Ỡ":"O","ỡ":"o","Ợ":"O","ợ":"o","Ụ":"U","ụ":"u","Ủ":"U","ủ":"u","Ứ":"U","ứ":"u","Ừ":"U","ừ":"u","Ử":"U","ử":"u","Ữ":"U","ữ":"u","Ự":"U","ự":"u","Ỳ":"Y","ỳ":"y","Ỵ":"Y","ỵ":"y","Ỷ":"Y","ỷ":"y","Ỹ":"Y","ỹ":"y","–":"-","‘":"\'","’":"\'","“":"\\\"","”":"\\\"","„":"\\\"","†":"+","•":"*","…":"...","₠":"ecu","₢":"cruzeiro","₣":"french franc","₤":"lira","₥":"mill","₦":"naira","₧":"peseta","₨":"rupee","₩":"won","₪":"new shequel","₫":"dong","€":"euro","₭":"kip","₮":"tugrik","₯":"drachma","₰":"penny","₱":"peso","₲":"guarani","₳":"austral","₴":"hryvnia","₵":"cedi","₸":"kazakhstani tenge","₹":"indian rupee","₺":"turkish lira","₽":"russian ruble","₿":"bitcoin","℠":"sm","™":"tm","∂":"d","∆":"delta","∑":"sum","∞":"infinity","♥":"love","元":"yuan","円":"yen","﷼":"rial","ﻵ":"laa","ﻷ":"laa","ﻹ":"lai","ﻻ":"la"}')
  var locales = JSON.parse('{"bg":{"Й":"Y","Ц":"Ts","Щ":"Sht","Ъ":"A","Ь":"Y","й":"y","ц":"ts","щ":"sht","ъ":"a","ь":"y"},"de":{"Ä":"AE","ä":"ae","Ö":"OE","ö":"oe","Ü":"UE","ü":"ue","ß":"ss","%":"prozent","&":"und","|":"oder","∑":"summe","∞":"unendlich","♥":"liebe"},"es":{"%":"por ciento","&":"y","<":"menor que",">":"mayor que","|":"o","¢":"centavos","£":"libras","¤":"moneda","₣":"francos","∑":"suma","∞":"infinito","♥":"amor"},"fr":{"%":"pourcent","&":"et","<":"plus petit",">":"plus grand","|":"ou","¢":"centime","£":"livre","¤":"devise","₣":"franc","∑":"somme","∞":"infini","♥":"amour"},"pt":{"%":"porcento","&":"e","<":"menor",">":"maior","|":"ou","¢":"centavo","∑":"soma","£":"libra","∞":"infinito","♥":"amor"},"uk":{"И":"Y","и":"y","Й":"Y","й":"y","Ц":"Ts","ц":"ts","Х":"Kh","х":"kh","Щ":"Shch","щ":"shch","Г":"H","г":"h"},"vi":{"Đ":"D","đ":"d"},"da":{"Ø":"OE","ø":"oe","Å":"AA","å":"aa","%":"procent","&":"og","|":"eller","$":"dollar","<":"mindre end",">":"større end"},"nb":{"&":"og","Å":"AA","Æ":"AE","Ø":"OE","å":"aa","æ":"ae","ø":"oe"},"it":{"&":"e"},"nl":{"&":"en"},"sv":{"&":"och","Å":"AA","Ä":"AE","Ö":"OE","å":"aa","ä":"ae","ö":"oe"}}')

  function replace (string, options) {
    if (typeof string !== 'string') {
      throw new Error('slugify: string argument expected')
    }

    options = (typeof options === 'string')
      ? {replacement: options}
      : options || {}

    var locale = locales[options.locale] || {}

    var replacement = options.replacement === undefined ? '-' : options.replacement

    var trim = options.trim === undefined ? true : options.trim

    var slug = string.normalize().split('')
      // replace characters based on charMap
      .reduce(function (result, ch) {
        var appendChar = locale[ch];
        if (appendChar === undefined) appendChar = charMap[ch];
        if (appendChar === undefined) appendChar = ch;
        if (appendChar === replacement) appendChar = ' ';
        return result + appendChar
          // remove not allowed characters
          .replace(options.remove || /[^\w\s$*_+~.()'"!\-:@]+/g, '')
      }, '');

    if (options.strict) {
      slug = slug.replace(/[^A-Za-z0-9\s]/g, '');
    }

    if (trim) {
      slug = slug.trim()
    }

    // Replace spaces with replacement character, treating multiple consecutive
    // spaces as a single space.
    slug = slug.replace(/\s+/g, replacement);

    if (options.lower) {
      slug = slug.toLowerCase()
    }

    return slug
  }

  replace.extend = function (customMap) {
    Object.assign(charMap, customMap)
  }

  return replace
}))


/***/ })

}]);